/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_CHR_CALENDAR_ITEM = {
  id: 'checks_sidebar_calendar',
  screenId: 'fin-chr-calendar',
  label: 'Calendario',
  description: 'Vencimientos de cheques recibidos.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Planificá cobros viendo en una grilla de 30 días qué cheques recibidos vencen cada día y cuánto suman.',
      },
      {
        title: 'Cómo usarlo',
        fields: [
          {
            label: 'Primer día del calendario',
            description: 'Elegí desde qué fecha arranca la vista (por defecto ayer). Se muestran 30 días consecutivos.',
          },
        ],
        bullets: [
          'Arriba ves totales: a vencer, pagados, cobrados por ventanilla, rechazados y no aceptados (según haya cheques en ese rango).',
          'Cada día muestra el día de la semana, la fecha, el importe total del día y la lista de cheques (número, cliente, monto).',
          'El día de hoy se resalta. Los montos cambian de color según el estado (pagado, rechazado, etc.).',
          'Los días sin cheques dicen «Sin cheques».',
        ],
      },
    ],
  },
}
